module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "activate-company"
  }, [_c('div', {
    staticClass: "landing-page-wrapper"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [_c('div', {
    staticClass: "activate-company__hero"
  }, [(_vm.emailValidCode === 1 || _vm.emailValidCode === 2) ? [_c('h1', {
    staticClass: "page-title"
  }, [(_vm.emailValidCode === 1) ? _c('svg', {
    staticClass: "svg-inline--fa fa-circle-check fa-w-16",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "circle-check",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM371.8 211.8l-128 128C238.3 345.3 231.2 348 224 348s-14.34-2.719-19.81-8.188l-64-64c-10.91-10.94-10.91-28.69 0-39.63c10.94-10.94 28.69-10.94 39.63 0L224 280.4l108.2-108.2c10.94-10.94 28.69-10.94 39.63 0C382.7 183.1 382.7 200.9 371.8 211.8z"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.emailValidCode === 1) ? [_vm._v("\n              Your email was successfully validated.\n            ")] : [_vm._v("\n              Your email was already validated.\n            ")]], 2), _vm._v(" "), _c('p', {
    staticClass: "page-description"
  }, [(_vm.emailValidCode === 1) ? [_vm._v("\n              In 10 seconds you will be redirected to the login page to finish your registration. If you are not redirected please click the link below.\n            ")] : [_vm._v("\n              In 10 seconds you will be redirected to the login page. If you are not redirected please click the link below.\n            ")]], 2), _vm._v(" "), _c('div', {
    staticClass: "activate-company__hero--count-down"
  }, [_vm._v("\n            Redirecting you to login in..."), _c('span', [_vm._v(_vm._s(_vm.redirectCountDown))])]), _vm._v(" "), _c('div', {
    staticClass: "activate-company__hero--actions"
  }, [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Go to the login page")])], 1)] : (_vm.emailValidCode === 3 || _vm.emailValidCode === 4) ? [_c('h1', {
    staticClass: "page-title"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-circle-exclamation fa-w-16",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "circle-exclamation",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM232 152C232 138.8 242.8 128 256 128s24 10.75 24 24v128c0 13.25-10.75 24-24 24S232 293.3 232 280V152zM256 400c-17.36 0-31.44-14.08-31.44-31.44c0-17.36 14.07-31.44 31.44-31.44s31.44 14.08 31.44 31.44C287.4 385.9 273.4 400 256 400z"
    }
  })]), _vm._v("\n            Error 508 - Invalid token."), _c('br'), _vm._v("\n            The activation token you used is invalid.\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "page-description"
  }, [_vm._v("\n            Please insert your email address in the field below to receive an email with a new activation token.\n          ")]), _vm._v(" "), _c('form', {
    staticClass: "activate-company__hero--form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.resendActivationToken()
      }
    }
  }, [_c('div', {
    staticClass: "landing-page-login-group",
    class: [{
      'active': _vm.resendActivationLinkForm.email !== '' || _vm.resendActivationLinkForm.emailFocus,
      'has-error': _vm.errors.has('Email')
    }]
  }, [_c('label', {
    attrs: {
      "for": "register-email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.resendActivationLinkForm.email),
      expression: "resendActivationLinkForm.email"
    }],
    class: [{
      'border-1-20': _vm.resendActivationLinkForm.email !== '' || _vm.resendActivationLinkForm.emailFocus
    }],
    attrs: {
      "id": "register-email",
      "data-lpignore": "true",
      "type": "email",
      "name": "Email"
    },
    domProps: {
      "value": (_vm.resendActivationLinkForm.email)
    },
    on: {
      "focus": function($event) {
        _vm.resendActivationLinkForm.emailFocus = true
      },
      "blur": function($event) {
        _vm.resendActivationLinkForm.emailFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.resendActivationLinkForm, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Send activation link")])]), _vm._v(" "), (_vm.emailValidCode === 4) ? [_c('div', {
    staticClass: "activate-company__hero--form__error"
  }, [_c('svg', {
    staticClass: "svg-inline--fa fa-circle-xmark fa-w-16",
    attrs: {
      "aria-hidden": "true",
      "focusable": "false",
      "data-prefix": "fas",
      "data-icon": "circle-xmark",
      "role": "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256C397.4 512 512 397.4 512 256S397.4 0 256 0zM336.1 303c9.375 9.375 9.375 24.56 0 33.94c-9.381 9.381-24.56 9.373-33.94 0L256 289.9l-47.03 47.03c-9.381 9.381-24.56 9.373-33.94 0c-9.375-9.375-9.375-24.56 0-33.94l47.03-47.03L175 208.1c-9.375-9.375-9.375-24.56 0-33.94s24.56-9.375 33.94 0L256 222.1l47.03-47.03c9.375-9.375 24.56-9.375 33.94 0s9.375 24.56 0 33.94l-47.03 47.03L336.1 303z"
    }
  })]), _vm._v(" "), _c('div', [_vm._v("It looks like it didn't work. Please "), _c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("get in touch")]), _vm._v(".")], 1)])] : _vm._e()] : (_vm.emailValidCode === 5) ? [_c('h1', {
    staticClass: "page-title activate-company-email-sent"
  }, [_vm._v("\n            We have sent you a new email.\n          ")]), _vm._v(" "), _vm._m(0)] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "contact-cta"
  }, [_c('div', {
    staticClass: "contact-cta--content"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "contact-cta--actions"
  }, [_c('router-link', {
    attrs: {
      "to": "/callback-request"
    }
  }, [_vm._v("Request a callback")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("Message us")])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "page-description activate-company-email-sent"
  }, [_vm._v("\n            Please "), _c('strong', [_vm._v("follow the instructions from the email to validate your email address")]), _vm._v(" and move forward to the next step."), _c('br'), _vm._v("\n            The link we have just sent you will expire in 24 hours.\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-cta--content__title"
  }, [_c('h2', {
    staticClass: "content"
  }, [_vm._v("Do you need our help?"), _c('br'), _c('strong', [_vm._v("Get in touch")]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-cta--content__text"
  }, [_c('p', {
    staticClass: "content"
  }, [_vm._v("\n            If there's something you'd like to ask us about Clear Assured, including our COVID-19 Toolkit, or you would like to arrange a demo, please feel free to fill in the form below, drop us an email or give us a call. We look forward to hearing from you.\n          ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c1141c8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/subscriptions/ActivateCompany.vue
// module id = 971
// module chunks = 0